// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"6d63a815","489":"f9cfc7c2","592":"c7a27d85","608":"ec356186","787":"f30b9f29","829":"43deb6da","838":"c0d16db8"}[chunkId] + ".chunk.js";
};